import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import {
    apiSignIn,
    apiSignOut,
    apiSignUp,
    apiAdminSignIn,
} from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'

function useAuth() {
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const userSignIn = async (values) => {
        try {
            const resp = await apiSignIn(values)
            console.log('voter profile', resp)
            if (resp.data) {
                const { token } = resp.data
                // console.log("token", token, resp)
                dispatch(onSignInSuccess(token))
                if (resp.data.id) {
                    dispatch(
                        setUser({
                            name: resp.data.name,
                            authority: [resp.data.user_type],
                            email: resp.data.email,
                            id: resp.data.id,
                            img: resp.data.user_img,
                        })
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(redirectUrl ? redirectUrl : appConfig.userEntryPath)
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const adminSignIn = async (values) => {
        try {
            const resp = await apiAdminSignIn(values)
            if (resp.data) {
                // const { token, email, id, name, user_type } = resp.data
                const { token } = resp.data
                // console("token", token, resp)
                dispatch(onSignInSuccess(token))
                if (resp.data.id) {
                    dispatch(
                        setUser({
                            name: resp.data.name,
                            authority: [resp.data.user_type],
                            email: resp.data.email,
                            id: resp.data.id,
                            img: resp.data.user_img,
                        })
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(redirectUrl ? redirectUrl : appConfig.adminEntryPath)
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: ['USER'],
                                email: '',
                            }
                        )
                    )
                }
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = () => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        navigate(appConfig.unAuthenticatedEntryPath)
    }

    const signOut = async () => {
        await apiSignOut()
        handleSignOut()
    }

    return {
        authenticated: token && signedIn,
        userSignIn,
        adminSignIn,
        signUp,
        signOut,
    }
}

export default useAuth
